import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import type { ReactElement } from "react";
import { useAuth } from "../core/auth/AuthContext";
import { AdminLayout } from "./layout/AdminLayout";
import { LoginPage } from "../features/login/LoginPage";
import { DashboardPage } from "../features/dashboard/DashboardPage";
import { UserAdminPage } from "../features/users/UserAdminPage";
import { PlacesPage } from "../features/places/PlacesPage";
import { UserDetailPage } from "../features/userDetail/UserDetailPage";
import { FriendshipsPage } from "../features/friendships/FriendshipsPage";
import { WecommendationsPage } from "../features/wecommendations/WecommendationsPage";
import { CollectionsPage } from "../features/collections/CollectionsPage";
import { SharesPage } from "../features/shares/SharesPage";

function Protected({ children }: { children: ReactElement }) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

export function AppRouter() {
  const { isAuthenticated } = useAuth();

  return (
    <HashRouter>
      <Routes>
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />}
        />
        <Route
          path="/"
          element={
            <Protected>
              <AdminLayout />
            </Protected>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="users" element={<UserAdminPage />} />
          <Route path="users/:userId" element={<UserDetailPage />} />
          <Route path="friendships" element={<FriendshipsPage />} />
          <Route path="places" element={<PlacesPage mode="all" />} />
          <Route path="wecommendations" element={<WecommendationsPage />} />
          <Route path="collections" element={<CollectionsPage />} />
          <Route path="shares" element={<SharesPage />} />
        </Route>
        <Route
          path="*"
          element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />}
        />
      </Routes>
    </HashRouter>
  );
}
